var BrowseNoDealsErrorPresenter, BrowseNoDealsErrorView, BrowseNoDealsMessageTemplate;

BrowseNoDealsErrorPresenter = require('../presenters/no_deals_error');

BrowseNoDealsMessageTemplate = require('../../no_deals_message.html.mustache');

module.exports = BrowseNoDealsErrorView = {
  template: BrowseNoDealsMessageTemplate,
  render: function(lastUpdatedRefinementId) {
    var noDealsHash;
    if (!(lastUpdatedRefinementId != null ? lastUpdatedRefinementId.length : void 0)) {
      return;
    }
    noDealsHash = BrowseNoDealsErrorPresenter.toHash(lastUpdatedRefinementId);
    if (noDealsHash) {
      return this.template.render(noDealsHash);
    }
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWRjYWJhbGxlcm8vbmFwaXN0cmFuby9idWlsZC8xNDkyNDY3OTc1Mzc5LTM3OTUyL3N0YWdpbmctMjAxNy4wNC4xN18yMi4xNS9nb29kcy9tb2R1bGVzL2Jyb3dzZS9mcm9udGVuZC92aWV3cy9ub19kZWFsc19lcnJvci5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9hZGNhYmFsbGVyby9uYXBpc3RyYW5vL2J1aWxkLzE0OTI0Njc5NzUzNzktMzc5NTIvc3RhZ2luZy0yMDE3LjA0LjE3XzIyLjE1L2dvb2RzL21vZHVsZXMvYnJvd3NlL2Zyb250ZW5kL3ZpZXdzL25vX2RlYWxzX2Vycm9yLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBOztBQUFBLDJCQUFBLEdBQThCLE9BQUEsQ0FBUSw4QkFBUjs7QUFDOUIsNEJBQUEsR0FBK0IsT0FBQSxDQUFRLHNDQUFSOztBQUUvQixNQUFNLENBQUMsT0FBUCxHQUFpQixzQkFBQSxHQUNmO0VBQUEsUUFBQSxFQUFVLDRCQUFWO0VBRUEsTUFBQSxFQUFRLFNBQUMsdUJBQUQ7QUFDTixRQUFBO0lBQUEsSUFBQSxvQ0FBYyx1QkFBdUIsQ0FBRSxnQkFBdkM7QUFBQSxhQUFBOztJQUNBLFdBQUEsR0FBYywyQkFBMkIsQ0FBQyxNQUE1QixDQUFtQyx1QkFBbkM7SUFDZCxJQUFpQyxXQUFqQzthQUFBLElBQUMsQ0FBQSxRQUFRLENBQUMsTUFBVixDQUFpQixXQUFqQixFQUFBOztFQUhNLENBRlIifQ==
